import Vue from 'vue';
import axios from 'axios';
import Vuex from 'vuex';
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, email, min, max, confirmed, length, numeric } from 'vee-validate/dist/rules';
import Toasted from 'vue-toasted';

var api = axios.create({
    headers: {
        Accept: "application/json",
        "Content-type": "application/json"
    }
});

Vue.use(Vuex);
var store = new Vuex.Store({
    state: {
        notification: {},
        openOrderDatails: "",
        formErrors: {},
        isLoading: false,
        fiden2CardAdded: false,
        siteConfig: [],
        pointsAnimationTimeDuration: 0,
        vouchers: []
    },
    getters: {
        getConfigValue: function (state) { return function (name) {
            var filtered = state.siteConfig.find(function (item) { return item.name === name; });
            if (filtered) {
                return filtered.value;
            }
            return null;
        }; }
    },
    mutations: {
        notification: function (state, notification) {
            state.notification = notification;
        },
        openOrderDatails: function (state, orderNumber) {
            state.openOrderDatails = orderNumber;
        },
        loading: function (state, loading) {
            state.isLoading = loading;
        },
        formErrors: function (state, formErrors) {
            state.formErrors = formErrors;
        },
        fiden2CardAdded: function (state, value) {
            state.fiden2CardAdded = value;
        },
        siteConfig: function (state, siteConfig) {
            state.siteConfig = siteConfig;
        },
        pointsAnimationTimeDuration: function (state, duration) {
            state.pointsAnimationTimeDuration = duration;
        },
        vouchers: function (state, vouchers) {
            state.vouchers = vouchers;
        }
    }
});

var namespace = Symbol("axios-retry");
var SAFE_HTTP_METHODS = ["get", "head", "options"];
function isRetryableError(error) {
    return (error.code !== "ECONNABORTED" &&
        (!error.response ||
            (error.response.status >= 500 && error.response.status <= 599)));
}
function isSafeRequestError(error) {
    if (!error.config) {
        return false;
    }
    return (isRetryableError(error) && SAFE_HTTP_METHODS.includes(error.config.method));
}
function isNetworkError(error) {
    return (!error.response && Boolean(error.code) && error.code !== "ECONNABORTED");
}
function isNetworkOrSafeRequestError(error) {
    return isNetworkError(error) || isSafeRequestError(error);
}
function getCurrentState(axios) {
    var currentState = axios[namespace] || {};
    currentState.retryCount = currentState.retryCount || 0;
    axios[namespace] = currentState;
    return currentState;
}
function getRequestOptions(config, defaultOptions) {
    return Object.assign({}, defaultOptions, config[namespace]);
}
function axiosInterceptor(axios, defaultOptions) {
    axios.interceptors.request.use(function (config) {
        var currentState = getCurrentState(axios);
        currentState.lastRequestTime = Date.now();
        return config;
    });
    axios.interceptors.response.use(function (config) {
        // const contentType = config.headers["content-type"];
        // if (contentType && contentType.indexOf("application/json") === -1) {
        //   return Promise.reject();
        // }
        return config;
    }, function (error) {
        var config = error.config;
        error.fetched = true;
        if (!config) {
            return Promise.reject(error);
        }
        if (error.response &&
            (401 === error.response.status || 403 === error.response.status)) {
            window.location.href = "/auth";
        }
        else {
            var _a = getRequestOptions(config, defaultOptions), _b = _a.retries, retries = _b === void 0 ? 3 : _b, _c = _a.retryCondition, retryCondition = _c === void 0 ? isNetworkOrSafeRequestError : _c, _d = _a.retryDelay, retryDelay_1 = _d === void 0 ? 3500 : _d;
            var currentState = getCurrentState(axios);
            var shouldRetry = retryCondition(error) && currentState.retryCount < retries;
            if (shouldRetry) {
                currentState.retryCount++;
                config.transformRequest = [function (data) { return data; }];
                return new Promise(function (resolve) {
                    return setTimeout(function () { return resolve(axios(config)); }, retryDelay_1);
                });
            }
        }
        if (error.code !== "ECONNABORTED") {
            var notification = {};
            if (error.response && 400 === error.response.status) {
                notification.message = "NCP Invalid form data";
                notification.type = "error";
                if (error.response.data) {
                    store.commit("formErrors", error.response.data);
                }
            }
            else if (error.response &&
                404 === error.response.status &&
                isSafeRequestError(error)) {
                notification.message = "NCP An error occurred";
                notification.type = "error-reload";
                notification.onComplete = function () {
                    return Promise.reject(error);
                };
                notification.onReload = function () {
                    return axios(config);
                };
            }
            if (notification.message && notification.type) {
                store.commit("notification", notification);
            }
        }
        if (error.code !== "ECONNABORTED" || error.response.status === 401) {
            error.fetched = false;
        }
        return Promise.reject(error);
    });
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        var arguments$1 = arguments;

        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments$1[i];
            for (var p in s) { if (Object.prototype.hasOwnProperty.call(s, p)) { t[p] = s[p]; } }
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) { throw t[1]; } return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) { throw new TypeError("Generator is already executing."); }
        while (_) { try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) { return t; }
            if (y = 0, t) { op = [op[0] & 2, t.value]; }
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) { _.ops.pop(); }
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; } }
        if (op[0] & 5) { throw op[1]; } return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var script = Vue.extend({
    props: {
        size: {
            type: Number,
            "default": 64
        },
        color: {
            type: String,
            "default": "#143616"
        },
        minHeight: {
            type: String,
            "default": null
        },
        minWidth: {
            type: String,
            "default": null
        },
        verticalAlign: {
            type: String,
            "default": null
        },
        horizontalAlign: {
            type: String,
            "default": null
        }
    },
    computed: {
        borderWidth: function () {
            return this.size < 64 ? 3 : 6;
        },
        styles: function () {
            return {
                width: this.size + "px",
                height: this.size + "px",
                "border-width": this.borderWidth + "px",
                "border-color": this.color + " transparent transparent transparent"
            };
        },
        containerStyle: function () {
            return {
                width: this.size + "px",
                height: this.size + "px"
            };
        },
        wrapperStyle: function () {
            var minHeight = "auto";
            var minWidth = "auto";
            var horizontalAlign = "initial";
            var verticalAlign = "initial";
            if (this.verticalAlign === "middle") {
                verticalAlign = "center";
            }
            else if (this.verticalAlign === "bottom") {
                verticalAlign = "self-end";
            }
            else if (this.verticalAlign === "top") {
                verticalAlign = "self-start";
            }
            if (this.horizontalAlign === "center") {
                horizontalAlign = "center";
            }
            else if (this.horizontalAlign === "left") {
                horizontalAlign = "flex-start";
            }
            else if (this.horizontalAlign === "right") {
                horizontalAlign = "flex-end";
            }
            if (this.minHeight) {
                minHeight = this.minHeight + "px";
            }
            if (this.minWidth) {
                minWidth = this.minWidth + "px";
            }
            return {
                "min-height": minHeight,
                "min-width": minWidth,
                "align-items": verticalAlign,
                "justify-content": horizontalAlign
            };
        }
    }
});

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-wrapper",style:(_vm.wrapperStyle)},[_c('div',{staticClass:"loader-ring",style:(_vm.containerStyle)},[_c('div',{style:(_vm.styles)}),_vm._v(" "),_c('div',{style:(_vm.styles)}),_vm._v(" "),_c('div',{style:(_vm.styles)}),_vm._v(" "),_c('div',{style:(_vm.styles)})])])};
var __vue_staticRenderFns__ = [];

  /* style */
  var __vue_inject_styles__ = function (inject) {
    if (!inject) { return }
    inject("data-v-104ec3ed_0", { source: "h1[data-v-104ec3ed],h2[data-v-104ec3ed],h3[data-v-104ec3ed],h4[data-v-104ec3ed],h5[data-v-104ec3ed],h6[data-v-104ec3ed]{margin:0}.customer-panel[data-v-104ec3ed]{background-color:#fff}.customer-panel-body[data-v-104ec3ed],.customer-panel-header[data-v-104ec3ed]{display:flex;flex-wrap:wrap;position:relative;padding:0 20px}@media screen and (max-width:640px){.customer-panel-body[data-v-104ec3ed],.customer-panel-header[data-v-104ec3ed]{flex-direction:column;padding:0 .5em}}.customer-panel-content[data-v-104ec3ed]{border-top:1px solid #dad4c5;flex:3}@media screen and (max-width:640px){.customer-panel-content[data-v-104ec3ed]{border-top:none}}.customer-panel-content h2[data-v-104ec3ed]{margin-top:20px;font-weight:400}@media screen and (max-width:640px){.customer-panel-content h2[data-v-104ec3ed]{text-align:center;font-size:26px;margin-top:25px}}@media screen and (max-width:640px){.customer-avatar[data-v-104ec3ed]{display:none}}@media screen and (max-width:640px){.customer-panel-personal-info .nickname[data-v-104ec3ed]{display:none}}.l-header[data-v-104ec3ed]{height:unset}.loader-wrapper[data-v-104ec3ed]{display:flex}.loader-wrapper .loader-ring[data-v-104ec3ed]{display:inline-block;position:relative;vertical-align:middle}.loader-wrapper .loader-ring div[data-v-104ec3ed]{box-sizing:border-box;display:block;position:absolute;border:6px solid #fff;border-radius:50%;animation:loader-ring-data-v-104ec3ed 1.2s cubic-bezier(.5,0,.5,1) infinite}.loader-wrapper .loader-ring div[data-v-104ec3ed]:nth-child(1){animation-delay:-.45s}.loader-wrapper .loader-ring div[data-v-104ec3ed]:nth-child(2){animation-delay:-.3s}.loader-wrapper .loader-ring div[data-v-104ec3ed]:nth-child(3){animation-delay:-.15s}@keyframes loader-ring-data-v-104ec3ed{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}", map: undefined, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__ = "data-v-104ec3ed";
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

var script$1 = Vue.extend({
    name: "SaveButton",
    components: {
        Loader: __vue_component__
    },
    props: {
        classes: {
            type: String,
            "default": ""
        },
        text: {
            type: String,
            "default": ""
        },
        color: {
            type: String,
            "default": "green"
        },
        saving: {
            type: Boolean,
            "default": false
        }
    },
    methods: {
        send: function (event) {
            event.preventDefault();
            this.$emit("send");
        }
    }
});

/* script */
var __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn",class:_vm.classes,on:{"click":function($event){$event.stopPropagation();return _vm.send.apply(null, arguments)}}},[(_vm.saving)?_c('loader',{attrs:{"size":15,"color":"#fff"}}):_vm._e(),_vm._v("\n    "+_vm._s(_vm._f("i18n")(_vm.text))+"\n  ")],1)])};
var __vue_staticRenderFns__$1 = [];

  /* style */
  var __vue_inject_styles__$1 = function (inject) {
    if (!inject) { return }
    inject("data-v-84d7e93e_0", { source: "@charset \"UTF-8\";h1[data-v-84d7e93e],h2[data-v-84d7e93e],h3[data-v-84d7e93e],h4[data-v-84d7e93e],h5[data-v-84d7e93e],h6[data-v-84d7e93e]{margin:0}.customer-panel[data-v-84d7e93e]{background-color:#fff}.customer-panel-body[data-v-84d7e93e],.customer-panel-header[data-v-84d7e93e]{display:flex;flex-wrap:wrap;position:relative;padding:0 20px}@media screen and (max-width:640px){.customer-panel-body[data-v-84d7e93e],.customer-panel-header[data-v-84d7e93e]{flex-direction:column;padding:0 .5em}}.customer-panel-content[data-v-84d7e93e]{border-top:1px solid #dad4c5;flex:3}@media screen and (max-width:640px){.customer-panel-content[data-v-84d7e93e]{border-top:none}}.customer-panel-content h2[data-v-84d7e93e]{margin-top:20px;font-weight:400}@media screen and (max-width:640px){.customer-panel-content h2[data-v-84d7e93e]{text-align:center;font-size:26px;margin-top:25px}}@media screen and (max-width:640px){.customer-avatar[data-v-84d7e93e]{display:none}}@media screen and (max-width:640px){.customer-panel-personal-info .nickname[data-v-84d7e93e]{display:none}}.l-header[data-v-84d7e93e]{height:unset}.btn[data-v-84d7e93e]{cursor:pointer;position:relative;height:36px;background:#143616;color:#fff;font-size:14px;line-height:19px;font-weight:700;text-align:center;padding:0 26px 0 17px;text-transform:none;border:1px solid #143616;font-family:\"Open Sans\",sans-serif;transition:background-color .2s ease}@media screen and (max-width:640px){.btn[data-v-84d7e93e]{padding:0 17px}}.btn[data-v-84d7e93e]:after{position:absolute;right:8px;top:12px;content:\"\";display:block;width:0;height:0;border-style:solid;border-width:6px 0 6px 6px;border-color:transparent transparent transparent #fff}@media screen and (max-width:640px){.btn[data-v-84d7e93e]:after{content:normal}}.btn.no-arrow[data-v-84d7e93e]{padding:0 10px}.btn.no-arrow[data-v-84d7e93e]:after{content:normal}.btn[data-v-84d7e93e]:hover{background:#0e2710;border-color:#143616}.btn.brown[data-v-84d7e93e]{color:#143616;background-color:#efe6da;border:1px solid #efe6da}.btn.brown[data-v-84d7e93e]:hover{background-color:#e9dccc}.btn.brown[data-v-84d7e93e]:after{border-color:transparent transparent transparent #143616}.btn.red[data-v-84d7e93e]{color:#fff;background-color:#b4023f;border:1px solid #91092f}.btn.red[data-v-84d7e93e]:hover{background-color:#91092f}.btn.red[data-v-84d7e93e]:after{border-color:transparent transparent transparent #fff}.btn.added-all-to-cart[data-v-84d7e93e]{padding:0 17px 0 17px;cursor:default}.btn.added-all-to-cart[data-v-84d7e93e]:after{border:none}.btn.added-all-to-cart[data-v-84d7e93e]:before{content:\"✔\"}.btn.added-all-to-cart[data-v-84d7e93e]:hover{background-color:#b4023f}.btn.unavailable[data-v-84d7e93e]{color:#fff;background-color:#dad4c5;border:1px solid #dad4c5;cursor:not-allowed}.btn.cart[data-v-84d7e93e]{background-color:#b4023f;animation-name:change-text;animation-duration:4s;border-color:#91092f}.btn.cart[data-v-84d7e93e]:hover{background-color:#91092f}.btn.cart[data-v-84d7e93e]:before{transition:all 1s ease;opacity:0;content:\"\"}.btn.cart.added[data-v-84d7e93e]:before{content:\"✔ \";opacity:1}.btn.cart.added[data-v-84d7e93e]:after{display:none}.btn.cart[data-v-84d7e93e]:after{border:none;position:relative;right:-8px;top:0;display:inline-block;content:\"\";margin:0 -1px;width:35px;height:35px;background:url(../img/basket.svg) no-repeat;background-size:23px 65px;vertical-align:middle}.btn.vip_zone_gold[data-v-84d7e93e]{color:#000;background-image:url(/img/alt_shop/vip_zone/VIP_button_koszyk_GOLD.png)!important}@media screen and (max-width:640px){.btn.vip_zone_gold[data-v-84d7e93e]{background-size:100%}}.btn.vip_zone_gold[data-v-84d7e93e]::after{border-color:transparent transparent transparent #000}.btn.vip_zone_gold[data-v-84d7e93e]:hover{background-image:url(/img/alt_shop/vip_zone/VIP_button_koszyk_GOLD_hover.png)!important}.btn.vip_zone_gold[data-v-84d7e93e]:before{opacity:0;content:\"\";background-image:url(/img/alt_shop/vip_zone/VIP_button_koszyk_GOLD_hover.png)!important}.btn.vip_zone_silver[data-v-84d7e93e]{color:#000;background-image:url(/img/alt_shop/vip_zone/VIP_button_koszyk_SILVER.png)!important}@media screen and (max-width:640px){.btn.vip_zone_silver[data-v-84d7e93e]{background-size:100%}}.btn.vip_zone_silver[data-v-84d7e93e]::after{border-color:transparent transparent transparent #000}.btn.vip_zone_silver[data-v-84d7e93e]:hover{background-image:url(/img/alt_shop/vip_zone/VIP_button_koszyk_SILVER_hover.png)!important}.btn.vip_zone_silver[data-v-84d7e93e]:before{opacity:0;content:\"\";background-image:url(/img/alt_shop/vip_zone/VIP_button_koszyk_SILVER_hover.png)!important}.btn.share-wishlist[data-v-84d7e93e]{padding:0 55px 0 17px}.btn.share-wishlist[data-v-84d7e93e]:after{border:none;right:16px;top:8px;background:url(/img/user_account/newsletter_icon_brown.png) no-repeat;background-size:27px 18px;height:18px;width:27px;content:\"\"!important}@media screen and (max-width:960px){.btn.share-wishlist[data-v-84d7e93e]{width:100%;padding:0}}.btn.share-email[data-v-84d7e93e],.btn.share-facebook[data-v-84d7e93e],.btn.share-messenger[data-v-84d7e93e]{padding:0 17px 0 40px;min-width:135px}.btn.share-email[data-v-84d7e93e]:before,.btn.share-facebook[data-v-84d7e93e]:before,.btn.share-messenger[data-v-84d7e93e]:before{position:absolute;border:none;display:block;content:\"\"}.btn.share-email[data-v-84d7e93e]:after,.btn.share-facebook[data-v-84d7e93e]:after,.btn.share-messenger[data-v-84d7e93e]:after{content:none}@media screen and (max-width:960px){.btn.share-email[data-v-84d7e93e],.btn.share-facebook[data-v-84d7e93e],.btn.share-messenger[data-v-84d7e93e]{width:100%;padding:0}}.btn.share-email[data-v-84d7e93e]:before{left:9px;top:6px;background:url(/img/user_account/ico_mail_white.svg) no-repeat;background-size:22px 22px;height:22px;width:22px}.btn.share-facebook[data-v-84d7e93e]:before{left:9px;top:6px;background:url(/img/user_account/facebook.svg) no-repeat;background-size:22px 22px;height:22px;width:22px}.btn.share-messenger[data-v-84d7e93e]:before{left:9px;top:6px;background:url(/img/user_account/messenger.svg) no-repeat;background-size:22px 22px;height:22px;width:22px}.btn.share-facebook[data-v-84d7e93e]{background-color:#4a68ad;border:1px solid #1c53a6}.btn.share-facebook[data-v-84d7e93e]:hover{background-color:#1c53a6}.btn.share-messenger[data-v-84d7e93e]{background-color:#3481f6;border:1px solid #0a73f6}.btn.share-messenger[data-v-84d7e93e]:hover{background-color:#0a73f6}.loader-wrapper[data-v-84d7e93e]{display:inline-block!important}.loader-wrapper[data-v-84d7e93e]{display:inline-block!important}", map: undefined, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$1 = "data-v-84d7e93e";
  /* module identifier */
  var __vue_module_identifier__$1 = undefined;
  /* functional template */
  var __vue_is_functional_template__$1 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    createInjector,
    undefined,
    undefined
  );

var i18n = require("roddeh-i18n");
extend("required", __assign(__assign({}, required), { message: "NCP This field is required." }));
extend("email", __assign(__assign({}, email), { message: "NCP Please enter a valid email address." }));
extend("min", __assign(__assign({}, min), { message: function (field, params) {
        return i18n("NCP Please enter at least {0} characters.").replace("{0}", params ? params["length"] : "");
    } }));
extend("max", __assign(__assign({}, max), { message: function (field, params) {
        return i18n("NCP Please enter no more than {0} characters.").replace("{0}", params ? params["length"] : "");
    } }));
extend("confirmed", __assign(__assign({}, confirmed), { message: "NCP Please enter the same value again." }));
extend("length", __assign(__assign({}, length), { message: function (field, params) {
        return i18n("NCP Please provide exactly {0} characters.").replace("{0}", params ? params["length"] : "");
    } }));
extend("numeric", __assign(__assign({}, numeric), { message: "NCP Please provide only numeric characters." }));
var script$2 = Vue.extend({
    name: "Validator",
    components: {
        ValidationProvider: ValidationProvider
    },
    props: {
        required: {
            type: Boolean,
            "default": false
        },
        readonly: {
            type: Boolean,
            "default": false
        },
        rules: {
            type: String,
            "default": ""
        },
        label: {
            type: String,
            "default": ""
        },
        type: {
            type: String,
            "default": ""
        },
        value: {
            type: String,
            "default": ""
        },
        fieldname: {
            type: String,
            "default": ""
        },
        description: {
            type: String,
            "default": ""
        },
        mode: {
            type: String,
            "default": "aggressive"
        },
        placeholder: {
            type: String,
            "default": ""
        },
        autocomplete: {
            type: String,
            "default": ""
        }
    },
    data: function () {
        return {
            fieldError: undefined
        };
    },
    computed: {
        formErrors: function () {
            return store.state.formErrors.errors ? store.state.formErrors.errors : [];
        },
        getPlaceholder: function () {
            return i18n(this.placeholder);
        },
        fieldLabel: function () {
            return i18n(this.label);
        }
    },
    watch: {
        formErrors: function (val) {
            var _this = this;
            var fieldError = val.find(function (i) { return i.field == _this.fieldname; });
            this.fieldError = fieldError;
        }
    },
    methods: {
        input: function () {
            store.commit("formErrors", {});
        }
    }
});

/* script */
var __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-provider',{attrs:{"rules":_vm.rules,"name":_vm._f("i18n")(_vm.label),"mode":_vm.mode},scopedSlots:_vm._u([{key:"default",fn:function(vee){return [(_vm.label)?_c('label',[_c('span',[_vm._v(_vm._s(_vm._f("i18n")(_vm.label)))]),_vm._v(" "),(_vm.required)?_c('span',[_vm._v("*")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.type === 'textarea')?_c('textarea',{class:{ error: vee.errors[0] },attrs:{"required":_vm.required,"type":_vm.type,"readonly":_vm.readonly,"aria-label":_vm.fieldLabel},domProps:{"value":_vm.value},on:{"input":function($event){_vm.input(); _vm.$emit('input', $event.target.value);},"keyup":function($event){_vm.input(); _vm.$emit('input', $event.target.value);}}}):_c('input',{class:{ error: vee.errors[0] },attrs:{"required":_vm.required,"type":_vm.type,"readonly":_vm.readonly,"placeholder":_vm.getPlaceholder,"autocomplete":_vm.autocomplete,"aria-label":_vm.fieldLabel},domProps:{"value":_vm.value},on:{"input":function($event){_vm.input(); _vm.$emit('input', $event.target.value);},"keyup":function($event){_vm.input(); _vm.$emit('input', $event.target.value);},"blur":function($event){return _vm.$emit('blur', $event)},"focus":function($event){return _vm.$emit('focus', $event)}}}),_vm._v(" "),(_vm.description)?_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm._f("i18n")(_vm.description)))]):_vm._e(),_vm._v(" "),(vee.errors[0])?_c('span',{staticClass:"input-error"},[_c('img',{attrs:{"src":"/img/user_account/ico_x.svg"}}),_vm._v("\n    "+_vm._s(_vm._f("i18n")(vee.errors[0]))+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.fieldError)?_c('span',{staticClass:"input-error"},[_c('img',{attrs:{"src":"/img/user_account/ico_x.svg"}}),_vm._v("\n    "+_vm._s(_vm.fieldError.message)+"\n  ")]):_vm._e()]}}])})};
var __vue_staticRenderFns__$2 = [];

  /* style */
  var __vue_inject_styles__$2 = function (inject) {
    if (!inject) { return }
    inject("data-v-3453afb8_0", { source: "h1[data-v-3453afb8],h2[data-v-3453afb8],h3[data-v-3453afb8],h4[data-v-3453afb8],h5[data-v-3453afb8],h6[data-v-3453afb8]{margin:0}.customer-panel[data-v-3453afb8]{background-color:#fff}.customer-panel-body[data-v-3453afb8],.customer-panel-header[data-v-3453afb8]{display:flex;flex-wrap:wrap;position:relative;padding:0 20px}@media screen and (max-width:640px){.customer-panel-body[data-v-3453afb8],.customer-panel-header[data-v-3453afb8]{flex-direction:column;padding:0 .5em}}.customer-panel-content[data-v-3453afb8]{border-top:1px solid #dad4c5;flex:3}@media screen and (max-width:640px){.customer-panel-content[data-v-3453afb8]{border-top:none}}.customer-panel-content h2[data-v-3453afb8]{margin-top:20px;font-weight:400}@media screen and (max-width:640px){.customer-panel-content h2[data-v-3453afb8]{text-align:center;font-size:26px;margin-top:25px}}@media screen and (max-width:640px){.customer-avatar[data-v-3453afb8]{display:none}}@media screen and (max-width:640px){.customer-panel-personal-info .nickname[data-v-3453afb8]{display:none}}.l-header[data-v-3453afb8]{height:unset}.error[data-v-3453afb8]{color:#b4023f}input[data-v-3453afb8]{font-size:14px}@media screen and (max-width:960px){input[data-v-3453afb8]{border:2px solid #dad4c5}}textarea[data-v-3453afb8]{width:100%;min-height:200px;font-size:14px;resize:none}@media screen and (max-width:960px){textarea[data-v-3453afb8]{border:2px solid #dad4c5}}input[data-v-3453afb8]:read-only,textarea[data-v-3453afb8]:read-only{background-color:#eee}input[data-v-3453afb8]:read-only:focus,textarea[data-v-3453afb8]:read-only:focus{box-shadow:none;-webkit-box-shadow:none}.description[data-v-3453afb8]{font-size:12px;padding:10px 0 0 0;margin:0}.input-error[data-v-3453afb8]{display:block;margin-top:5px;font-size:14px;color:#b4023f}.input-error img[data-v-3453afb8]{display:inline-block;width:10px;height:10p}", map: undefined, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$2 = "data-v-3453afb8";
  /* module identifier */
  var __vue_module_identifier__$2 = undefined;
  /* functional template */
  var __vue_is_functional_template__$2 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$2 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    createInjector,
    undefined,
    undefined
  );

var i18n$1 = require("roddeh-i18n");
extend("requiredCheckbox", __assign(__assign({}, required), { message: function (field) { return i18n$1("NCP Check this field to continue."); } }));
var script$3 = Vue.extend({
    name: "Validator",
    components: {
        ValidationProvider: ValidationProvider
    },
    props: {
        required: {
            type: Boolean,
            "default": false
        },
        label: {
            type: String,
            "default": ""
        },
        id: {
            type: Number,
            "default": null
        },
        fieldname: {
            type: String,
            "default": ""
        },
        value: {
            type: Boolean,
            "default": false
        },
        errors: {
            type: Array,
            "default": function () { return []; }
        },
        compact: {
            type: Boolean,
            "default": false
        },
        center: {
            type: Boolean,
            "default": false
        },
        block: {
            type: Boolean,
            "default": false
        }
    },
    data: function () {
        return {
            checkbox: this.value,
            fieldError: undefined
        };
    },
    computed: {
        formErrors: function () {
            return store.state.formErrors.errors ? store.state.formErrors.errors : [];
        },
        rulesSet: function () {
            if (!this.required) {
                return {};
            }
            return { requiredCheckbox: { allowFalse: false } };
        },
        translatedLabel: function () {
            return i18n$1(this.label);
        }
    },
    watch: {
        formErrors: function (val) {
            var _this = this;
            var fieldError = val.find(function (i) { return i.field == _this.fieldname; });
            this.fieldError = fieldError;
        }
    },
    methods: {
        changeCheckbox: function () {
            store.commit("formErrors", {});
            this.$emit("changeCheckbox", this.checkbox, this.id);
        },
        setValue: function (checked, propagate) {
            if (propagate === void 0) { propagate = true; }
            if (checked) {
                this.checkbox = true;
            }
            else {
                this.checkbox = false;
            }
            if (propagate) {
                this.changeCheckbox();
            }
        }
    }
});

/* script */
var __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-provider',{attrs:{"rules":_vm.rulesSet,"name":_vm._f("i18n")(_vm.label)},scopedSlots:_vm._u([{key:"default",fn:function(vee){return [_c('div',{class:{ 'form-group': true, 'compact': _vm.compact }},[_c('label',{class:{ center: _vm.center, block: _vm.block },attrs:{"for":_vm.id}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.translatedLabel)}}),_vm._v(" "),(_vm.required)?_c('span',[_vm._v("*")]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkbox),expression:"checkbox"}],class:{ error: vee.errors[0] },attrs:{"id":_vm.id,"required":_vm.required,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.checkbox)?_vm._i(_vm.checkbox,null)>-1:(_vm.checkbox)},on:{"change":[function($event){var $$a=_vm.checkbox,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkbox=$$a.concat([$$v]));}else {$$i>-1&&(_vm.checkbox=$$a.slice(0,$$i).concat($$a.slice($$i+1)));}}else {_vm.checkbox=$$c;}},_vm.changeCheckbox]}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),(vee.errors[0])?_c('span',{staticClass:"input-error"},[_c('img',{attrs:{"src":"/img/user_account/ico_x.svg"}}),_vm._v("\n      "+_vm._s(_vm._f("i18n")(vee.errors[0]))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.fieldError)?_c('span',{staticClass:"input-error"},[_c('img',{attrs:{"src":"/img/user_account/ico_x.svg"}}),_vm._v("\n      "+_vm._s(_vm.fieldError.message)+"\n    ")]):_vm._e()])]}}])})};
var __vue_staticRenderFns__$3 = [];

  /* style */
  var __vue_inject_styles__$3 = function (inject) {
    if (!inject) { return }
    inject("data-v-e3af9d64_0", { source: "h1[data-v-e3af9d64],h2[data-v-e3af9d64],h3[data-v-e3af9d64],h4[data-v-e3af9d64],h5[data-v-e3af9d64],h6[data-v-e3af9d64]{margin:0}.customer-panel[data-v-e3af9d64]{background-color:#fff}.customer-panel-body[data-v-e3af9d64],.customer-panel-header[data-v-e3af9d64]{display:flex;flex-wrap:wrap;position:relative;padding:0 20px}@media screen and (max-width:640px){.customer-panel-body[data-v-e3af9d64],.customer-panel-header[data-v-e3af9d64]{flex-direction:column;padding:0 .5em}}.customer-panel-content[data-v-e3af9d64]{border-top:1px solid #dad4c5;flex:3}@media screen and (max-width:640px){.customer-panel-content[data-v-e3af9d64]{border-top:none}}.customer-panel-content h2[data-v-e3af9d64]{margin-top:20px;font-weight:400}@media screen and (max-width:640px){.customer-panel-content h2[data-v-e3af9d64]{text-align:center;font-size:26px;margin-top:25px}}@media screen and (max-width:640px){.customer-avatar[data-v-e3af9d64]{display:none}}@media screen and (max-width:640px){.customer-panel-personal-info .nickname[data-v-e3af9d64]{display:none}}.l-header[data-v-e3af9d64]{height:unset}.error[data-v-e3af9d64]{color:#b4023f}.input-error[data-v-e3af9d64]{display:block;margin-top:5px;font-size:14px;color:#b4023f}.input-error img[data-v-e3af9d64]{display:inline-block;width:10px;height:10p}.form-group[data-v-e3af9d64]{position:relative;margin-bottom:20px;user-select:none}.form-group label[data-v-e3af9d64]{padding-left:35px;font-weight:400;font-size:14px;text-align:left;cursor:pointer}.form-group label.center[data-v-e3af9d64]{padding-top:7px}.form-group label.block[data-v-e3af9d64]{display:block}.form-group input[data-v-e3af9d64]{position:absolute;opacity:0;cursor:pointer;height:0;width:0}.form-group input:checked~.checkmark[data-v-e3af9d64]{background-color:#143616;border:2px solid #143616}.form-group input:checked~.checkmark[data-v-e3af9d64]:after{display:block}.form-group input.error~.checkmark[data-v-e3af9d64]{border:2px solid #b4023f}.form-group .checkmark[data-v-e3af9d64]{position:absolute;top:0;left:0;height:25px;width:25px;background-color:#eee;border:2px solid #eee;transition:background-color .2s ease}.form-group .checkmark[data-v-e3af9d64]:after{content:\"\";position:absolute;display:none;top:50%;left:50%;transform:translate(-50%,-60%) rotate(45deg);width:5px;height:10px;border:solid #fff;border-width:0 3px 3px 0}.form-group:hover input~.checkmark[data-v-e3af9d64]{background-color:#ccc}.form-group:hover input:checked~.checkmark[data-v-e3af9d64]{background-color:#143616}.compact[data-v-e3af9d64]{margin-bottom:10px}.compact span.checkmark[data-v-e3af9d64]{height:15px;width:15px}.compact span.checkmark[data-v-e3af9d64]::after{transform:translate(-50%,-65%) rotate(45deg)}.compact .input-error[data-v-e3af9d64],.compact label[data-v-e3af9d64]{padding-left:25px}", map: undefined, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$3 = "data-v-e3af9d64";
  /* module identifier */
  var __vue_module_identifier__$3 = undefined;
  /* functional template */
  var __vue_is_functional_template__$3 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$3 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    false,
    createInjector,
    undefined,
    undefined
  );

/* eslint-disable @typescript-eslint/camelcase */
var prepareAgreement = function (agreement) {
    return {
        description: agreement.description,
        id: agreement.id,
        scopes: agreement.scopes,
        sortOrder: agreement.sort_order
    };
};
var AgreementsApi = {
    getAll: function () {
        return new Promise(function (resolve, reject) {
            api
                .get("/api/configuration/agreements")
                .then(function (response) {
                var agreements = [];
                response.data.forEach(function (agreement) {
                    agreements.push(prepareAgreement(agreement));
                });
                resolve(agreements);
            })["catch"](function (error) {
                reject(error);
            });
        });
    },
    getByScope: function (scopeName) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.getAll()
                .then(function (agreements) {
                var filtered = agreements.filter(function (agreement) {
                    return agreement.scopes.some(function (_a) {
                        var scope = _a.scope;
                        return scope == scopeName;
                    });
                });
                resolve(filtered);
            })["catch"](function (error) {
                reject(error);
            });
        });
    }
};

var Gender;
(function (Gender) {
    Gender["MALE"] = "M";
    Gender["FEMALE"] = "F";
})(Gender || (Gender = {}));
var AccountApi = {
    create: function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof (payload.activation_in_app) === 'undefined') {
                            payload.activation_in_app = false; // eslint-disable-line @typescript-eslint/camelcase
                        }
                        return [4 /*yield*/, api.post('/api/customer/register', payload)];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        });
    },
    logIn: function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        formData.set('login', payload.login);
                        formData.set('password', payload.password);
                        return [4 /*yield*/, api.post('/auth/login', formData, {
                                headers: { 'content-type': 'multipart/form-data' }
                            })];
                    case 1:
                        response = (_a.sent()).data;
                        if (typeof (response.success) === 'undefined' || response.success === false) {
                            throw new Error('Invalid credentials');
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
};

var i18n$2 = require("roddeh-i18n");
Vue.use(Toasted);
var script$4 = Vue.extend({
    name: "Toast",
    props: {
        duration: {
            type: Number,
            "default": 3000
        },
        position: {
            type: String,
            "default": function () { return "top-center"; }
        },
        actions: {
            type: [Object, Array],
            "default": function () {
                return ({});
            }
        }
    },
    computed: {
        notification: function () {
            return store.state.notification;
        }
    },
    watch: {
        notification: function () {
            if (this.notification.clear) {
                this.$toasted.clear();
            }
            if (this.notification.type === "error-reload") {
                this.errorReload(this.notification);
            }
            else if (this.notification.type === "error") {
                this.error(this.notification.message);
            }
            else if (this.notification.type === "success") {
                this.success(this.notification.message);
            }
        }
    },
    methods: {
        errorReload: function (notification) {
            if (notification.error && notification.error.status !== 400) {
                var toastOptions = {
                    duration: 5000,
                    position: "top-center",
                    className: "yr-toast",
                    onComplete: function () {
                        notification.onComplete();
                    }
                };
                notification.message = "NCP An error occurred";
                toastOptions.action = [
                    {
                        text: i18n$2("NCP Try again"),
                        onClick: function (e, toastObject) {
                            notification.onReload();
                            toastObject.goAway(0);
                        }
                    },
                    {
                        text: i18n$2("NCP Cancel"),
                        onClick: function (e, toastObject) {
                            if (notification.onComplete) {
                                notification.onComplete();
                            }
                            toastObject.goAway(0);
                        }
                    }
                ];
                this.$toasted.error(i18n$2(notification.message), toastOptions);
            }
        },
        error: function (text) {
            this.$toasted.error(i18n$2(text), {
                duration: this.duration,
                position: "top-center",
                className: "yr-toast"
            });
        },
        success: function (text) {
            this.$toasted.success(i18n$2(text), {
                duration: this.duration,
                className: "yr-toast",
                position: "top-center"
            });
        },
        confirm: function () {
            this.$emit("confirm");
            this.$toasted.clear();
        },
        clear: function () {
            this.$toasted.clear();
        }
    }
});

/* script */
var __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')};
var __vue_staticRenderFns__$4 = [];

  /* style */
  var __vue_inject_styles__$4 = function (inject) {
    if (!inject) { return }
    inject("data-v-3873e5a4_0", { source: "h1,h2,h3,h4,h5,h6{margin:0}.customer-panel{background-color:#fff}.customer-panel-body,.customer-panel-header{display:flex;flex-wrap:wrap;position:relative;padding:0 20px}@media screen and (max-width:640px){.customer-panel-body,.customer-panel-header{flex-direction:column;padding:0 .5em}}.customer-panel-content{border-top:1px solid #dad4c5;flex:3}@media screen and (max-width:640px){.customer-panel-content{border-top:none}}.customer-panel-content h2{margin-top:20px;font-weight:400}@media screen and (max-width:640px){.customer-panel-content h2{text-align:center;font-size:26px;margin-top:25px}}@media screen and (max-width:640px){.customer-avatar{display:none}}@media screen and (max-width:640px){.customer-panel-personal-info .nickname{display:none}}.l-header{height:unset}@media screen and (max-width:960px){.toasted-container.top-center{top:auto;left:0;bottom:0;-webkit-transform:translateX(0);transform:translateX(0)}}.yr-toast.toasted.toasted-primary.error{background-color:#b4023f;padding:15px 40px;font-size:20px}.yr-toast.toasted.toasted-primary.success{background-color:#143616;padding:15px 40px;font-size:20px}.yr-toast.toasted .action{color:#fff;text-decoration:underline}.yr-toast.toasted ul{list-style-type:disc;margin-top:20px}", map: undefined, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$4 = undefined;
  /* module identifier */
  var __vue_module_identifier__$4 = undefined;
  /* functional template */
  var __vue_is_functional_template__$4 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$4 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    false,
    createInjector,
    undefined,
    undefined
  );

function showNotification(type, message, error, onReload, onComplete, clear) {
    if (type === "success" || type === "error") {
        store.commit("notification", {
            type: type,
            message: message,
            clear: clear
        });
    }
    else if (type === "error-reload") {
        store.commit("notification", {
            type: type,
            error: error,
            onReload: onReload,
            onComplete: onComplete
        });
    }
}
var notifications = {
    showSuccess: function (message, clear) {
        if (clear === void 0) { clear = false; }
        showNotification("success", message, null, null, null, clear);
    },
    showError: function (error, onReload, onComplete) {
        showNotification("error-reload", "", error, onReload, onComplete);
    },
    showTextError: function (message, clear) {
        if (clear === void 0) { clear = false; }
        showNotification("error", message, null, null, null, clear);
    }
};

var i18n$3 = require("roddeh-i18n"); // eslint-disable-line @typescript-eslint/no-var-requires, no-undef
var Gender$1;
(function (Gender) {
    Gender["MALE"] = "M";
    Gender["FEMALE"] = "F";
})(Gender$1 || (Gender$1 = {}));
var script$5 = Vue.extend({
    name: "Register",
    components: {
        SaveBtn: __vue_component__$1,
        Toast: __vue_component__$4,
        ValidationObserver: ValidationObserver,
        Validator: __vue_component__$2,
        ValidatorCheckbox: __vue_component__$3
    },
    props: {
        mode: {
            type: String,
            "default": "registration_regular"
        },
        autologin: {
            type: String,
            "default": "false"
        },
        nextPage: {
            type: String,
            "default": "/customer/registered"
        },
        mainPage: {
            type: String,
            "default": "/"
        },
        mobileRegexp: {
            type: String,
            "default": "^\\+[0-9]{2}\\d{9}$"
        },
        mobileDefaultPrefix: {
            type: String,
            "default": ""
        },
        mobilePlaceholder: {
            type: String,
            "default": ""
        },
        googleClientId: {
            type: String,
            "default": ""
        },
        googleAuthEnabled: {
            type: String,
            "default": "0"
        },
        facebookAuthEnabled: {
            type: String,
            "default": "0"
        },
        seznamAuthEnabled: {
            type: String,
            "default": "0"
        },
        seznamClientId: {
            type: String,
            "default": ""
        },
        appleAuthEnabled: {
            type: String,
            "default": "0"
        },
        campaign: {
            type: String,
            "default": ""
        },
        refLink: {
            type: String,
            "default": ""
        },
        mgmEnabled: {
            type: String,
            "default": "0"
        },
        selectAllAgreementsEnabled: {
            type: String,
            "default": "0"
        }
    },
    data: function () {
        var baseData = {
            duringSocialAuth: false,
            socialAuthProvider: null,
            noSocialEmail: false,
            noSocialFirstName: false,
            noSocialLastName: false,
            firstName: "",
            lastName: "",
            email: "",
            password: "",
            gender: null,
            mobile: "",
            agreements: [],
            checkedAgreements: [],
            loading: true,
            saving: false,
            refLinkInput: ""
        };
        // Przełącznie formularza w tryb rejestracji z danymi z FB/Google (jeżeli podano)
        // Źródło danych: parametr GET "data", wartości: JSON zbase64-encodowany
        // Przykład:
        // /customer/register?data=JTI1N0IlMjUyMnNvdXJjZSUyNTIyJTI1M0ElMjUyMkZhY2Vib29rJTI1MjIlMjUyQyUyNTIyZmlyc3ROYW1lJTI1MjIlMjUzQSUyNTIyJTI1dTAxNDF1a2FzeiUyNTIyJTI1MkMlMjUyMmVtYWlsJTI1MjIlMjUzQSUyNTIycnJ1dGVrJTQwZ21haWwuY29tJTI1MjIlMjUyQyUyNTIybGFzdE5hbWUlMjUyMiUyNTNBJTI1MjJSdXRrb3dza2klMjUyMiUyNTdE
        var urlParams = new URLSearchParams(window.location.search);
        var data = urlParams.get("data");
        if (typeof data === "string") {
            try {
                var decoded = unescape(decodeURIComponent(atob(data)));
                var json = JSON.parse(decoded);
                baseData.duringSocialAuth = true;
                baseData.socialAuthProvider = json.source;
                if (typeof json.firstName !== 'undefined' && json.firstName !== null && json.firstName.length > 0) {
                    baseData.firstName = json.firstName;
                }
                else {
                    baseData.noSocialFirstName = true;
                }
                if (typeof json.lastName !== "undefined" && json.lastName !== null && json.lastName.length > 0) {
                    baseData.lastName = json.lastName;
                }
                else {
                    baseData.noSocialLastName = true;
                }
                if (typeof json.email !== "undefined" && json.email !== null && json.email.length > 0) {
                    baseData.email = json.email;
                }
                else {
                    baseData.noSocialEmail = true;
                }
                if (typeof json.phoneNumber !== "undefined" && json.phoneNumber !== null && json.phoneNumber.length > 0) {
                    baseData.mobile = json.phoneNumber;
                }
            }
            catch (err) {
                console.error("Failed to parse data query param", err);
            }
        }
        return baseData;
    },
    computed: {
        observer: function () {
            return this.$refs.observer;
        },
        isFacebookAuthEnabled: function () {
            if (this.facebookAuthEnabled === "1") {
                return true;
            }
            return false;
        },
        isGoogleAuthEnabled: function () {
            if (this.googleAuthEnabled === "1") {
                return true;
            }
            return false;
        },
        isSeznamAuthEnabled: function () {
            if (this.seznamAuthEnabled === "1") {
                return true;
            }
            return false;
        },
        isAppleAuthEnabled: function () {
            if (this.appleAuthEnabled === "1") {
                return true;
            }
            return false;
        },
        isMgmEnabled: function () {
            if (this.mgmEnabled === "1") {
                return true;
            }
            return false;
        }
    },
    created: function () {
        return __awaiter(this, void 0, void 0, function () {
            var agreements;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        extend("mobile", {
                            message: "Enter number in 123-456-789 format",
                            validate: function (value) { return new RegExp(_this.mobileRegexp).test(value); }
                        });
                        return [4 /*yield*/, AgreementsApi.getByScope(this.mode)];
                    case 1:
                        agreements = _a.sent();
                        this.agreements = agreements.map(function (base) {
                            return {
                                id: base.id,
                                label: base.description,
                                checked: _this.isAgreementChecked(base),
                                required: _this.isAgreementRequired(base)
                            };
                        });
                        this.loading = false;
                        if (this.mobile.length === 0) {
                            this.mobile = this.mobileDefaultPrefix;
                        }
                        if (this.mode !== 'registration_onetime') {
                            this.refLinkInput = this.refLink;
                        }
                        return [2 /*return*/];
                }
            });
        });
    },
    methods: {
        socialAuthSigning: function () {
            this.loading = true;
            this.duringSocialAuth = true;
        },
        socialAuthSignedIn: function (event) {
            this.duringSocialAuth = true;
            this.noSocialEmail = false;
            this.noSocialFirstName = false;
            this.noSocialLastName = false;
            if (event.detail.type == "logged") {
                // Przekierowania po zalogowaniu
                if (this.nextPage !== "/customer/registered") {
                    document.location.href = this.nextPage;
                }
                else if (typeof event.detail.redirectTo === "string") {
                    document.location.href = event.detail.redirectTo;
                }
                else {
                    document.location.href = this.mainPage;
                }
            }
            else if (event.detail.type == "account_created") {
                this.socialAuthProvider = event.detail.source;
                this.firstName = event.detail.firstName;
                this.lastName = event.detail.lastName;
                if (event.detail.firstName === null || event.detail.firstName.length === 0) {
                    this.noSocialFirstName = true;
                }
                if (event.detail.lastName === null || event.detail.lastName.length === 0) {
                    this.noSocialLastName = true;
                }
                this.email = event.detail.email;
                if (!event.detail.email) {
                    this.noSocialEmail = true;
                }
                if (typeof (event.detail.phoneNumber) !== 'undefined' && event.detail.phoneNumber !== null) {
                    this.mobile = event.detail.phoneNumber;
                }
                this.loading = false;
            }
            else {
                this.duringSocialAuth = false;
                this.loading = false;
            }
        },
        socialAuthCanceled: function () {
            this.duringSocialAuth = false;
            this.socialAuthProvider = null;
            this.loading = false;
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        ensureMobileContainsPrefix: function (e) {
            var regex = new RegExp(this.mobileRegexp);
            var fixedMobile = "" + this.mobileDefaultPrefix + this.mobile;
            if (regex.test(fixedMobile)) {
                this.mobile = "" + this.mobileDefaultPrefix + this.mobile;
            }
        },
        isAgreementRequired: function (agreement) {
            var _this = this;
            var required = false;
            agreement.scopes.forEach(function (scope) {
                if (scope.scope === _this.mode && scope.mandatory) {
                    required = true;
                }
            });
            return required;
        },
        isAgreementChecked: function (agreement) {
            var _this = this;
            var checked = false;
            agreement.scopes.forEach(function (scope) {
                if (scope.scope === _this.mode && scope.selected) {
                    checked = true;
                }
            });
            return checked;
        },
        translate: function (str) {
            return i18n$3(str);
        },
        checkForm: function () {
            var _this = this;
            this.observer
                .validate()
                .then(function (response) { return (response ? _this.send() : ""); });
        },
        send: function () {
            var _this = this;
            if (this.saving === true) {
                return;
            }
            this.saving = true;
            AccountApi.create({
                first_name: this.firstName,
                last_name: this.lastName,
                email: this.email,
                password: this.password,
                password2: this.password,
                gender: this.gender,
                mobile: this.mobile,
                agreements: this.checkedAgreements,
                is_onetime: this.mode === "registration_onetime",
                social_auth: this.duringSocialAuth,
                consider_activated: this.autologin === "true",
                campaign: this.campaign != '' ? this.campaign : undefined,
                ref_link: this.refLinkInput != '' ? this.refLinkInput : undefined
            })
                .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                var password;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(this.autologin === "true" ||
                                typeof response.from_social_app !== "undefined")) { return [3 /*break*/, 2]; }
                            password = this.password;
                            if (typeof response.temporary_password !== "undefined") {
                                password = response.temporary_password;
                            }
                            return [4 /*yield*/, AccountApi.logIn({
                                    login: this.email,
                                    password: password
                                })
                                    .then(function () {
                                    document.location.href = _this.nextPage;
                                })["catch"](function () {
                                    _this.saving = false;
                                    notifications.showError(i18n$3("Failed to automatically log in"));
                                })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                        case 2:
                            document.location.href = this.nextPage;
                            return [2 /*return*/];
                    }
                });
            }); })["catch"](function () {
                _this.saving = false;
            });
        },
        changeCheckbox: function (value, id) {
            var index = this.checkedAgreements.indexOf(id);
            if (value && index < 0) {
                this.checkedAgreements.push(id);
            }
            else if (!value && index > -1) {
                this.checkedAgreements.splice(index, 1);
            }
            // Ustaw "Zaznacz wszystkie zgody" jako zaznaczony/odznaczony
            if (typeof (this.$refs.selectAllAgreementsCheckbox) !== 'undefined') {
                this.$refs.selectAllAgreementsCheckbox.setValue(this.checkedAgreements.length === this.agreements.length, false);
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        selectAllAgreements: function (value, id) {
            if (Array.isArray(this.$refs.agreementCheckboxes)) {
                for (var _i = 0, _a = this.$refs.agreementCheckboxes; _i < _a.length; _i++) {
                    var checkbox = _a[_i];
                    checkbox.setValue(value);
                }
            }
        }
    }
});

/* script */
var __vue_script__$5 = script$5;

/* template */
var __vue_render__$5 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"bg-left"}),_vm._v(" "),_c('div',{staticClass:"bg-right"}),_vm._v(" "),(_vm.mode != 'registration_onetime')?_c('h1',[_c('b',[_vm._v(_vm._s(_vm._f("i18n")("NRF Create account")))]),_vm._v("\n      "+_vm._s(_vm._f("i18n")("NRF in internet shop"))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.mode == 'registration_onetime')?_c('h1',[_c('b',[_vm._v(_vm._s(_vm._f("i18n")("NRF Fill in data")))]),_vm._v("\n      "+_vm._s(_vm._f("i18n")("NRF for order processing"))+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{class:{ 'form': true, 'loadingBlur': _vm.loading }},[((_vm.isFacebookAuthEnabled || _vm.isGoogleAuthEnabled || _vm.isSeznamAuthEnabled || _vm.isAppleAuthEnabled) && _vm.mode !== 'registration_onetime' && _vm.socialAuthProvider === null)?_c('div',{staticClass:"social-login-box"},[(_vm.isFacebookAuthEnabled)?_c('div',{staticClass:"social-login-button"},[_c('facebook-auth-button',{on:{"signed":_vm.socialAuthSignedIn,"signing":function () { return _vm.socialAuthSigning(); },"canceled":_vm.socialAuthCanceled}})],1):_vm._e(),_vm._v(" "),(_vm.isGoogleAuthEnabled)?_c('div',{staticClass:"social-login-button"},[_c('div',{attrs:{"id":"google-auth-button"},on:{"signed":_vm.socialAuthSignedIn,"signing":function () { return _vm.socialAuthSigning(); },"canceled":_vm.socialAuthCanceled}})]):_vm._e(),_vm._v(" "),(_vm.isSeznamAuthEnabled)?_c('div',{staticClass:"social-login-button"},[_c('seznam-auth-button',{attrs:{"clientId":_vm.seznamClientId},on:{"signed":_vm.socialAuthSignedIn,"signing":function () { return _vm.socialAuthSigning(); },"canceled":_vm.socialAuthCanceled}})],1):_vm._e(),_vm._v(" "),(_vm.isAppleAuthEnabled)?_c('div',{staticClass:"social-login-button"},[_c('div',{attrs:{"id":"appleid-signin","data-color":"black","data-border":"true","data-type":"sign in"},on:{"signed":_vm.socialAuthSignedIn,"signing":function () { return _vm.socialAuthSigning(); },"canceled":_vm.socialAuthCanceled}})]):_vm._e()]):_vm._e(),_vm._v(" "),((_vm.isFacebookAuthEnabled || _vm.isGoogleAuthEnabled || _vm.isSeznamAuthEnabled || _vm.isAppleAuthEnabled) && _vm.mode !== 'registration_onetime' && _vm.socialAuthProvider === null)?_c('div',{staticClass:"line"},[_c('span',[_vm._v(_vm._s(_vm._f("i18n")('NRF or')))])]):_vm._e(),_vm._v(" "),(_vm.socialAuthProvider !== null)?_c('div',{staticClass:"social-data-notification"},[_vm._v("\n        "+_vm._s(_vm._f("i18n")("NRF We got your data from service"))+" "+_vm._s(_vm.socialAuthProvider)+_vm._s(_vm._f("i18n")("NRF please fill in missing data to continue"))+"\n      ")]):_vm._e(),_vm._v(" "),_c('validation-observer',{ref:"observer"},[_c('div',[_c('div',{staticClass:"form-group"},[_c('validator',{attrs:{"fieldname":"first_name","label":"NRF First name","type":"text","rules":"required|max:50","required":true,"autocomplete":"given-name","readonly":_vm.duringSocialAuth && !_vm.noSocialFirstName},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.checkForm.apply(null, arguments)}},model:{value:(_vm.firstName),callback:function ($$v) {_vm.firstName=$$v;},expression:"firstName"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('validator',{attrs:{"fieldname":"last_name","label":"NRF Last name","type":"text","rules":"required|max:80","required":true,"autocomplete":"family-name","readonly":_vm.duringSocialAuth && !_vm.noSocialLastName},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.checkForm.apply(null, arguments)}},model:{value:(_vm.lastName),callback:function ($$v) {_vm.lastName=$$v;},expression:"lastName"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('validator',{attrs:{"fieldname":"email","label":"NRF E-mail","type":"email","rules":"required|email|max:255","required":true,"autocomplete":"username","readonly":_vm.duringSocialAuth && !_vm.noSocialEmail},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.checkForm.apply(null, arguments)}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v;},expression:"email"}})],1),_vm._v(" "),(_vm.mode !== 'registration_onetime' && _vm.duringSocialAuth === false)?_c('div',{staticClass:"form-group"},[_c('validator',{attrs:{"fieldname":"password","label":"NRF Password","type":"password","rules":"required","required":true,"autocomplete":"new-password","placeholder":_vm.translate('NRF Minimum 6 characters')},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.checkForm.apply(null, arguments)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v;},expression:"password"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('validator',{attrs:{"fieldname":"mobile","label":"NRF Mobile","type":"tel","rules":"required|max:25|mobile","required":true,"placeholder":_vm.mobilePlaceholder,"autocomplete":"tel"},nativeOn:{"change":function($event){return _vm.ensureMobileContainsPrefix.apply(null, arguments)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.checkForm.apply(null, arguments)}},model:{value:(_vm.mobile),callback:function ($$v) {_vm.mobile=$$v;},expression:"mobile"}})],1)]),_vm._v(" "),(_vm.isMgmEnabled && _vm.mode !== 'registration_onetime')?_c('div',{staticClass:"form-group"},[_c('validator',{attrs:{"fieldname":"ref_link","label":"NRF Invitation code","type":"text","rules":"max:12","required":false,"autocomplete":"off"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.checkForm.apply(null, arguments)}},model:{value:(_vm.refLinkInput),callback:function ($$v) {_vm.refLinkInput=$$v;},expression:"refLinkInput"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group form-radio"},[_c('p',{staticClass:"gender"},[_vm._v("\n            "+_vm._s(_vm._f("i18n")("NRF Gender"))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"radio-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],attrs:{"id":"female","type":"radio","value":"F","name":"gender"},domProps:{"checked":_vm._q(_vm.gender,"F")},on:{"change":function($event){_vm.gender="F";}}}),_vm._v(" "),_c('label',{attrs:{"for":"female"}},[_vm._v(_vm._s(_vm._f("i18n")("NRF Female")))])]),_vm._v(" "),_c('div',{staticClass:"radio-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],attrs:{"id":"male","type":"radio","value":"M","name":"gender"},domProps:{"checked":_vm._q(_vm.gender,"M")},on:{"change":function($event){_vm.gender="M";}}}),_vm._v(" "),_c('label',{attrs:{"for":"male"}},[_vm._v(_vm._s(_vm._f("i18n")("NRF Male")))])])]),_vm._v(" "),_c('div',{staticClass:"agreements-list"},[(_vm.selectAllAgreementsEnabled === '1')?_c('div',{staticClass:"select-all"},[_c('validator-checkbox',{ref:"selectAllAgreementsCheckbox",attrs:{"id":-1,"required":false,"value":false,"compact":true,"fieldname":"agreement","label":_vm.translate('NRF Select all agreements')},on:{"changeCheckbox":_vm.selectAllAgreements}}),_vm._v(" "),_c('hr')],1):_vm._e(),_vm._v(" "),_vm._l((_vm.agreements),function(agreement){return _c('div',{key:agreement.id,class:{ 'indented': _vm.selectAllAgreementsEnabled === '1' }},[_c('validator-checkbox',{ref:"agreementCheckboxes",refInFor:true,attrs:{"id":agreement.id,"required":agreement.required,"value":false,"compact":true,"fieldname":"agreement","label":agreement.label},on:{"changeCheckbox":_vm.changeCheckbox}})],1)})],2)]),_vm._v(" "),(_vm.campaign != '')?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.campaign),expression:"campaign"}],attrs:{"type":"hidden","name":"campaign"},domProps:{"value":(_vm.campaign)},on:{"input":function($event){if($event.target.composing){ return; }_vm.campaign=$event.target.value;}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"submit"},[(_vm.mode === 'registration_onetime')?_c('save-btn',{attrs:{"text":_vm.translate('NRF Continue Ordering Btn'),"saving":_vm.saving},on:{"update:saving":function($event){_vm.saving=$event;},"send":_vm.checkForm}}):_c('save-btn',{attrs:{"text":_vm.translate('NRF Create account Btn'),"saving":_vm.saving},on:{"update:saving":function($event){_vm.saving=$event;},"send":_vm.checkForm}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"legal-info"},[_c('p',[_vm._v("* "+_vm._s(_vm._f("i18n")('required field')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("i18n")('INFORMACJA O PRZETWARZANIU DANYCH OSOBOWYCH')))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.translate('popup_administrator_bazy_danych'))}})]),_vm._v(" "),_c('toast')],1)};
var __vue_staticRenderFns__$5 = [];

  /* style */
  var __vue_inject_styles__$5 = function (inject) {
    if (!inject) { return }
    inject("data-v-1c0cb02c_0", { source: "h1[data-v-1c0cb02c],h2[data-v-1c0cb02c],h3[data-v-1c0cb02c],h4[data-v-1c0cb02c],h5[data-v-1c0cb02c],h6[data-v-1c0cb02c]{margin:0}.customer-panel[data-v-1c0cb02c]{background-color:#fff}.customer-panel-body[data-v-1c0cb02c],.customer-panel-header[data-v-1c0cb02c]{display:flex;flex-wrap:wrap;position:relative;padding:0 20px}@media screen and (max-width:640px){.customer-panel-body[data-v-1c0cb02c],.customer-panel-header[data-v-1c0cb02c]{flex-direction:column;padding:0 .5em}}.customer-panel-content[data-v-1c0cb02c]{border-top:1px solid #dad4c5;flex:3}@media screen and (max-width:640px){.customer-panel-content[data-v-1c0cb02c]{border-top:none}}.customer-panel-content h2[data-v-1c0cb02c]{margin-top:20px;font-weight:400}@media screen and (max-width:640px){.customer-panel-content h2[data-v-1c0cb02c]{text-align:center;font-size:26px;margin-top:25px}}@media screen and (max-width:640px){.customer-avatar[data-v-1c0cb02c]{display:none}}@media screen and (max-width:640px){.customer-panel-personal-info .nickname[data-v-1c0cb02c]{display:none}}.l-header[data-v-1c0cb02c]{height:unset}.container[data-v-1c0cb02c]{width:620px;margin:0 auto;padding:0;color:#5f472f;font-family:\"Open Sans\",sans-serif;position:relative}@media (max-width:620px){.container[data-v-1c0cb02c]{width:100%}}.container h1[data-v-1c0cb02c]{text-align:center;margin:40px 0;font-weight:400;font-size:2em}@media (max-width:620px){.container h1[data-v-1c0cb02c]{margin:20px 0}.container h1 b[data-v-1c0cb02c]{display:block}}.container .bg-left[data-v-1c0cb02c]{background:url(/img/register/register_form_left.png) no-repeat;width:230px;height:690px;position:absolute;left:-190px;top:90px}.container .bg-right[data-v-1c0cb02c]{background:url(/img/register/register_form_right.png) no-repeat;width:290px;height:690px;position:absolute;right:-211px;top:90px}@media (max-width:1050px){.container .bg-left[data-v-1c0cb02c],.container .bg-right[data-v-1c0cb02c]{display:none}}.container .social-login-box[data-v-1c0cb02c]{display:flex;flex-direction:column;align-items:center}.container .social-login-box .social-login-button[data-v-1c0cb02c]:not(:last-child){margin-bottom:15px}.container .social-login-box #appleid-signin[data-v-1c0cb02c]{height:40px}.form[data-v-1c0cb02c]{border:1px solid #d7d4cf;background:#fff;padding:50px;min-height:710px;box-sizing:border-box}@media (max-width:620px){.form[data-v-1c0cb02c]{border:none;padding:10px}}.form-group[data-v-1c0cb02c]{width:66%;margin:0 auto 20px}@media (max-width:620px){.form-group[data-v-1c0cb02c]{width:100%;margin:0 0 10px}}.form-group>span[data-v-1c0cb02c]{display:flex;flex-wrap:wrap;justify-content:flex-end}@media (max-width:620px){.form-group>span[data-v-1c0cb02c]{flex-direction:column}}.form-group>span[data-v-1c0cb02c] :nth-child(1){flex:1 0;flex-basis:30%;line-height:2em;font-weight:400}@media (max-width:620px){.form-group>span[data-v-1c0cb02c] :nth-child(1){margin-bottom:0}}.form-group>span[data-v-1c0cb02c] :nth-child(2){flex:1 0;flex-basis:65%}.form-group>span[data-v-1c0cb02c] :nth-child(3){flex-basis:65%}.form-radio[data-v-1c0cb02c]{width:66%;margin:0 auto 20px;display:flex}@media (max-width:620px){.form-radio[data-v-1c0cb02c]{width:100%;margin:0 0 10px;flex-wrap:wrap}}.form-radio>p[data-v-1c0cb02c]{flex-basis:40%;margin:0}@media (max-width:620px){.form-radio>p[data-v-1c0cb02c]{flex-basis:100%;margin:0 0 5px;line-height:2em}}.form-radio>.radio-group[data-v-1c0cb02c]{flex-basis:30%;display:flex}@media (max-width:620px){.form-radio>.radio-group[data-v-1c0cb02c]{flex-basis:50%}}.form-radio>.radio-group label[data-v-1c0cb02c]{margin:3px 30px 0 10px;padding-left:10px;font-weight:400}@media (max-width:620px){.form-radio>.radio-group label[data-v-1c0cb02c]{line-height:1.5em}}.form-radio>.radio-group input[data-v-1c0cb02c],.form-radio>.radio-group label[data-v-1c0cb02c]{cursor:pointer}.form-radio>.radio-group input[data-v-1c0cb02c]{position:relative}.form-radio>.radio-group input[data-v-1c0cb02c]::before{content:\" \";display:block;width:16px;height:16px;background:#fff;border-radius:15px;position:absolute;left:-5px;top:-1px;box-shadow:0 0 0 1px #5f472f;border:2px solid #fff;background:#fff}.form-radio>.radio-group input[data-v-1c0cb02c]:checked::before{background:#143616}.line[data-v-1c0cb02c]{border-bottom:1px solid #d7d8d2;margin:25px 0 35px;position:relative;text-align:center}.line span[data-v-1c0cb02c]{position:relative;top:9px;background:#fff;padding:0 25px}.submit[data-v-1c0cb02c]{text-align:center}.agreements-list[data-v-1c0cb02c]{margin:35px 0 50px}.agreements-list .indented[data-v-1c0cb02c]{padding-left:1em}.agreements-list .select-all hr[data-v-1c0cb02c]{margin:1em 0}.legal-info[data-v-1c0cb02c]{margin:40px auto;color:#988369;font-size:11px;line-height:16.5px;max-width:1248px;box-sizing:border-box;padding:0 10px}@media (max-width:1248px) and (min-width:960px){.legal-info[data-v-1c0cb02c]{max-width:960px}}@media (max-width:620px){.legal-info[data-v-1c0cb02c]{max-width:100%}}.legal-info div[data-v-1c0cb02c],.legal-info div[data-v-1c0cb02c] :nth-child(n),.legal-info p[data-v-1c0cb02c]{margin:0}.legal-info>p[data-v-1c0cb02c]:nth-child(1){margin:10px 0}.social-data-notification[data-v-1c0cb02c]{background:#143616;color:#fff;padding:1em;box-sizing:border-box;font-weight:600;margin:0 2em 2em}@media (max-width:620px){.social-data-notification[data-v-1c0cb02c]{margin:0 0 1em}}.loadingBlur[data-v-1c0cb02c]{filter:blur(4px);animation-name:heartFadeInOut-data-v-1c0cb02c;animation-timing-function:ease-in-out;animation-iteration-count:infinite;animation-duration:2s;animation-direction:alternate}@keyframes heartFadeInOut-data-v-1c0cb02c{0%{opacity:1}14%{opacity:1}28%{opacity:.5}42%{opacity:.5}70%{opacity:.5}}", map: undefined, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$5 = "data-v-1c0cb02c";
  /* module identifier */
  var __vue_module_identifier__$5 = undefined;
  /* functional template */
  var __vue_is_functional_template__$5 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$5 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
    __vue_inject_styles__$5,
    __vue_script__$5,
    __vue_scope_id__$5,
    __vue_is_functional_template__$5,
    __vue_module_identifier__$5,
    false,
    createInjector,
    undefined,
    undefined
  );

var i18n$4 = require("roddeh-i18n");
Vue.config.ignoredElements = [
    'google-auth-button',
    'facebook-auth-button',
    'seznam-auth-button'
];
Vue.filter("i18n", function (value) {
    return i18n$4(value);
});
axiosInterceptor(api, {});

export { __vue_component__$5 as Register };
